<template>
  <v-row class="top-content">
    <v-col cols="3" class="my-3 mx-2">
      <v-row>
        <v-col :cols="checkWidth > 1440 ? 3 : 4" id="avt" style="border-radius: 8px;">
          <img class="student-avatar" src="/img/avt.png" alt="">
        </v-col>
        <v-col :cols="checkWidth > 1440 ? 9 : 8">
          <div class="d-flex align-center mt-7">
            <div class="student-name" v-if="childSelected && childSelected.full_name">
              {{childSelected.full_name}}
            </div>
          </div>
          <div class="student-code">
            <div class="text-no-wrap" :style="{fontSize: checkWidth > 1440 ? '' : '12px'}">Mã khách hàng: <span v-if="contactData && contactData.code">{{contactData.code}}
            <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                size="small"
                rounder
                icon
                v-on="on"
                @click="handleCopy(contactData.code)"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip></span></div>
          </div>
        </v-col>
      </v-row>
      <div class="mt-2 mb-4" :style="{width: checkWidth > 1440 ? '65%' : '100%'}">
        <div class="d-flex align-center justify-space-around">
          <div v-for="(item,index) in actions " :key="item.key" style="cursor: pointer;">
            <div v-if="item.key === 'call' && phoneRelated.length > 0">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="d-flex flex-column align-center"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <img :src="item.img" alt="">
                    <div :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'" style="font-size: 11px">{{item.text}}</div>
                  </div>
                </template>
                <div style="background: white; padding: 8px">
                  <div class="mobile-box main" @click="clickExecuteCall(contactData, contactMobile)">
                    {{formatNormalStylePhone(contactMobile)}}
                  </div>
                  <div v-for="(item, index) in phoneRelated" :key="`phoneRelated` + index" class="mobile-box" @click="clickExecuteCall(contactData, item)">
                    {{formatNormalStylePhone(item)}}
                  </div>
                </div>
              </v-menu>
            </div>
            <v-tooltip
              top
              v-else
            >
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex flex-column align-center"
                  v-bind="attrs"
                  v-on="item.disable ? on : ''"
                  v-if="item.key === 'ticket' ? checkAuthorization('care-submit-ticket_read') : true"
                >
                  <img @click="item.disable ? '' : actionUser(item.key)" :src="item.img" alt="">
                  <div :class="index === 0 ? 'pt-2 mt-1' : 'mt-1'" style="font-size: 11px">{{item.text}}</div>
                </div>
              </template>
              <span>Tính năng chưa phát triển</span>
            </v-tooltip>
          </div>
        </div>
      </div>
      <div class="mt-2">Điện thoại:
        <span v-if="contactMobile">{{formatNormalStylePhone(contactMobile)}}
            <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                size="small"
                rounder
                icon
                v-on="on"
                @click="handleCopy(contactMobile)"
                class="ml-2"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Copy</span>
          </v-tooltip></span></div>
      <div class="mt-2">Ngày sinh: {{ childSelected.birthday }}</div>
      <div class="mt-2 d-flex align-center">
        <div class="mr-4">Phụ huynh: {{ handleShowParentName(mainCustomer.fullName) }}</div>
        <v-select
          :disabled="!childCustomers || !childCustomers.length"
          ref="child-select"
          class="select-child mt-0"
          @change="changeContactChild()"
          :items="childCustomers"
          :label="`${childCustomers.length} con khác`"
          item-text="full_name"
          item-value="id"
          flat
          hide-details
          dense
          no-data-text="Không có dữ liệu"
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="childSelectedId"
        >
        </v-select>
      </div>
      <div class="mt-2">Ngày phân học sinh: {{formatDate(contactData.assignedAt)}}</div>
      <!-- <div class="mt-2">Gọi cho khách hàng:
        <v-menu offset-y v-if="contactData.contactType == 'main'">
          <template v-slot:activator="{ on: on, attrs }">
            <v-btn
              size="16"
              width="20"
              height="20"
              class="mr-1"
              icon
              small
              color="success"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="16">mdi-phone</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="clickExecuteCall(contactData, contactMobile)"
              class="main-mobile"
            >
              <v-list-item-title>{{
                  contactData.mobile ? contactData.mobile : contactMobile
                }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-for="(phone, index) in contactData.phoneRelated"
              :key="index"
              @click="clickExecuteCall(contactData, phone)"
              class="sub-mobile"
            >
              <v-list-item-title>{{ phone }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <span
          @click="clickExecuteCall(contactData, contactMobile)"
          style="cursor: pointer;"
          v-else
        >
          <v-btn
            style="margin-left: -5px"
            icon
            small
            color="success"
            dark
          >
            <v-icon>mdi-phone</v-icon>
          </v-btn>
        </span>
        <span class="font-weight-bold">
          <span v-if="contactData.zuid">
            <img
              src="../../../../../public/img/zalo.svg"
              alt="Zalo"
              class="ml-1"
              style="width: 16px;height: 16px;vertical-align: middle;"
            />
          </span>
        </span>
      </div>
      <div class="mt-7 d-flex align-center">
        <v-btn
          @click="createOrder(contactData.id)"
          color="pink"
          class="white--text"
        >Tạo đơn</v-btn>
        <v-btn
          @click="createTicket(contactData)"
          color="pink"
          class="white--text ml-3"
          v-if="checkAuthorization('care-submit-ticket_read')"
        >Tạo ticket</v-btn>
      </div> -->
    </v-col>
    <v-col cols="9" class="my-3 mx-2">
      <v-row>
        <!-- <v-col cols="2">
          <v-tabs vertical v-model="currentTab" class="custom-tab" hide-slider>
            <v-tab v-for="(tab, index) in tabView"
                   :active-class="currentTab === index ? 'active-tab' : ''"
                   :key="`${tab}_${index}`"
                   class="justify-start"
                   :disabled="tab.disable"
                   @change="changeTabView(index)">
              <img src="../../assets/tab-detail-icon.svg" height="36" width="36" class="mr-4" alt="">
              {{ tab.title }}
              <img v-if="tab.title === 'Duo'" src="../../assets/cup-icon.svg" height="18" width="18" alt="" class="ml-3">
            </v-tab>
          </v-tabs>
        </v-col> -->
        <v-col cols="12">
          <div v-show="filter.typeViewFilter === 'detail'" class="w-100">
            <v-row>
              <v-col
                cols="12"
                v-if="activeClass === 0"
              >
                <v-tabs
                  v-model="activeTab"
                  vertical
                  hide-slider
                  class="custom-duo-tab"
                >
                  <v-tab>
                    <div class="d-flex align-center justify-start w-100">
                      <img v-if="activeTab === DUO_TOP_CONTENT_ACTIVE_TAB.HOMEWORK" src="../../assets/duo-tab-icon-active.svg" class="mr-2" alt="">
                      <img v-else src="../../assets/duo-tab-icon.svg" class="mr-2" alt="">
                      <span style="font-size: 14px; text-transform: none;">
                        Bài tập &
                        <br>
                        chuyên cần
                      </span>
                    </div>
                  </v-tab>
                  <v-tab>
                    <div class="d-flex align-center justify-start w-100">
                      <img v-if="activeTab === DUO_TOP_CONTENT_ACTIVE_TAB.TEST" src="../../assets/duo-tab-icon-active.svg" class="mr-2" alt="">
                      <img v-else src="../../assets/duo-tab-icon.svg" class="mr-2" alt="">
                      Kiểm tra
                    </div>
                  </v-tab>
                  <v-tab-item>
                    <DuoViewDetailBySubject
                      :dataTable="studyResult.bySubjectGrade"
                      :filterForm="filterForm"
                      :filter="filter"
                    ></DuoViewDetailBySubject>
                  </v-tab-item>
                  <v-tab-item>
                    <DuoTestTab
                      :items="dataTestDuo"
                      :subject-id="filterForm.subjectId"
                    >
                    </DuoTestTab>
                  </v-tab-item>
                </v-tabs>
                <note-filter-for-date
                  v-if="activeClass === 0"
                  :dateTime="filter.dateTime"
                  :lms-core-user-id="studentDuoDetail.lms_core_user_id"
                ></note-filter-for-date>
              </v-col>
              <v-col
                :cols="12"
                v-if="activeClass === 1"
              >
                <div class="d-flex justify-center align-center">
                  <SelfStudyViewDetailBySubject
                    :subject-id="filterForm.subjectId"
                    :dataTable="selfStudyResult.byGrade"
                  ></SelfStudyViewDetailBySubject>
                </div>
              </v-col>
<!--              <v-col-->
<!--                cols="6"-->
<!--                v-if="!isViewAll && activeClass === 1"-->
<!--              >-->
<!--                <DuoViewDetailBySkill-->
<!--                  :dataTable="dataTableBySkill">-->
<!--                </DuoViewDetailBySkill>-->
<!--              </v-col>-->
            </v-row>
          </div>
          <v-row v-show="filter.typeViewFilter === 'chart'">
            <v-col cols="12" class="d-flex justify-center">
              <div :class="{'active': activeChartType === DUO_CHART_TYPE.JOIN_CLASS_RATE}" class="mr-4 chart-type-btn" @click="activeChartType = DUO_CHART_TYPE.JOIN_CLASS_RATE">
                Tỉ lệ tham gia lớp học
              </div>
              <div :class="{'active': activeChartType === DUO_CHART_TYPE.AVERAGE_SCORE}" class="chart-type-btn" @click="activeChartType = DUO_CHART_TYPE.AVERAGE_SCORE">
                Điểm trung bình
              </div>
            </v-col>
            <div style="height: 400px; width: 100%">
              <chart v-if="isShowChart" :chartData="chartData" :activeChartType="activeChartType" ref="chart"/>
              <div v-else style="height: 100%" class="d-flex flex-column align-center justify-center">
                <img src="../../assets/no-data-duo-icon.svg" height="64" width="64" alt="">
                <div style="color: #828282" class="mt-2">
                  Học sinh chưa có thông tin điểm
                </div>
              </div>
            </div>
          </v-row>
<!--          <v-tabs-items v-model="currentTab">-->
<!--            <v-tab-item v-for="item in tabView" :key="item.tab" class="customs-v-card">-->
<!--              <v-card flat>-->
<!--                <v-card-text :class="!isViewAll && currentTab === 1 ? 'justify-lg-space-between' : ''" class="d-flex">-->
<!--                  <v-progress-circular-->
<!--                    v-if="loading"-->
<!--                    indeterminate-->
<!--                    color="primary"-->
<!--                    style="width: 100%"-->
<!--                  ></v-progress-circular>-->
<!--                  <template v-else>-->
<!--                    <div v-show="filter.typeViewFilter === 'detail'" class="w-100">-->
<!--                      <v-row>-->
<!--                        <v-col-->
<!--                          cols="12"-->
<!--                          v-if="currentTab === 0"-->
<!--                          :style="{marginTop: dataTableBySubjectClone  && dataTableBySubjectClone.length ? '' : '10%' }"-->
<!--                        >-->
<!--                          <DuoViewDetailBySubject-->
<!--                            :dataTable="dataTableBySubjectClone"-->
<!--                            :filterForm="filterForm"-->
<!--                            :filter="filter"-->
<!--                          ></DuoViewDetailBySubject>-->
<!--                        </v-col>-->
<!--                        <v-col-->
<!--                          :cols="isViewAll ? 12 : (dataTableBySubjectClone  && dataTableBySubjectClone.length ? 6 : 12)"-->
<!--                          v-if="currentTab === 1"-->
<!--                          :style="{marginTop: dataTableBySubjectClone  && dataTableBySubjectClone.length ? '' : '10%' }"-->
<!--                        >-->
<!--                          <SelfStudyViewDetailBySubject-->
<!--                            :dataTable="dataTableBySubjectClone"-->
<!--                          ></SelfStudyViewDetailBySubject>-->
<!--                        </v-col>-->
<!--                        <v-col-->
<!--                          cols="6"-->
<!--                          v-if="!isViewAll && currentTab === 1"-->
<!--                        >-->
<!--                          <DuoViewDetailBySkill-->
<!--                            :dataTable="dataTableBySkill">-->
<!--                          </DuoViewDetailBySkill>-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                      <note-filter-for-date-->
<!--                        v-if="dataTableBySubjectClone && dataTableBySubjectClone.length"-->
<!--                        :dateTime="filter.dateTime"-->
<!--                      ></note-filter-for-date>-->
<!--                    </div>-->
<!--                    <v-row v-show="filter.typeViewFilter === 'chart'">-->
<!--                      <v-col cols="12" class="d-flex justify-center">-->
<!--                        <div :class="{'active': activeChartType === DUO_CHART_TYPE.JOIN_CLASS_RATE}" class="mr-4 chart-type-btn" @click="activeChartType = DUO_CHART_TYPE.JOIN_CLASS_RATE">-->
<!--                          Tỉ lệ tham gia lớp học-->
<!--                        </div>-->
<!--                        <div :class="{'active': activeChartType === DUO_CHART_TYPE.AVERAGE_SCORE}" class="chart-type-btn" @click="activeChartType = DUO_CHART_TYPE.AVERAGE_SCORE">-->
<!--                          Điểm trung bình-->
<!--                        </div>-->
<!--                      </v-col>-->
<!--                      <div style="height: 400px; width: 100%">-->
<!--                        <chart v-if="isShowChart" :chartData="chartData" :activeChartType="activeChartType" ref="chart"/>-->
<!--                        <div v-else style="height: 100%" class="d-flex flex-column align-center justify-center">-->
<!--                          <img src="../../assets/no-data-duo-icon.svg" height="64" width="64" alt="">-->
<!--                          <div style="color: #828282" class="mt-2">-->
<!--                            Học sinh chưa có thông tin điểm-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </v-row>-->
<!--                  </template>-->
<!--                </v-card-text>-->
<!--              </v-card>-->
<!--            </v-tab-item>-->
<!--          </v-tabs-items>-->
        </v-col>
      </v-row>
    </v-col>
    <ModalInteraction
      v-if="showModalInteraction"
      :childSelected="childSelected"
      :filterForm="filterForm"
      :filter="filter"
      :subjectId="subjectId"
      :showModalInteraction="showModalInteraction"
    ></ModalInteraction>
  </v-row>
</template>

<script>
import DuoTestTab from '@/modules/duo_care/components/DuoTestTab.vue';
import Chart from '@/components/chart/Chart.vue';
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import NoteFilterForDate from '@/modules/student_detail_bt/components/ModalScoreDetail/NoteFilterForDate.vue';
import ContactRepository from '@/services/ContactRepository';
import { setPageTitle } from '@/helpers/utils';
import { DUO_TOP_CONTENT_ACTIVE_TAB, tabViewDuoCare } from '../../constant';
import TokenService from '../../../../helpers/token';
import DuoViewDetailBySubject from './DuoViewDetailBySubject.vue';
import SelfStudyViewDetailBySubject from './SelfStudyViewDetailBySubject.vue';
import ModalInteraction from './ModalInteraction.vue';
import StudentCareServices from '../../../../services/StudentCareServices';
import { TYPE_CURRICULUM_OBJ, DUO_CHART_TYPE } from '../../../../helpers/constant';

export default {
  name: 'StudentCareTopContent',
  components: {
    SelfStudyViewDetailBySubject, DuoViewDetailBySubject, ModalInteraction, Chart, NoteFilterForDate, DuoTestTab,
  },
  props: ['studentDuoDetail', 'contactData', 'filterForm', 'filter', 'studentId'],
  data() {
    return {
      DUO_TOP_CONTENT_ACTIVE_TAB,
      activeTab: 0,
      dataTestDuo: [],
      dataSelfStudyResult: [],
      phoneRelated: [],
      DUO_CHART_TYPE,
      chartData: null,
      subjectId: null,
      contactMobile: '',
      mainCustomer: {},
      childCustomers: [],
      childSelected: {},
      childSelectedId: null,
      tabView: tabViewDuoCare,
      currentTab: 0,
      isShowChart: true,
      dataTableBySkill: [],
      dataTableBySubject: [],
      dataTableBySubjectClone: [],
      showModalInteraction: false,
      loading: false,
      activeChartType: DUO_CHART_TYPE.JOIN_CLASS_RATE,
      actions: [
        { key: 'call', text: 'Gọi điện', img: '/img/call.png' },
        {
          key: 'zalo', text: 'Gọi Zalo', img: '/img/zalo.png', disable: true,
        },
        { key: 'order', text: 'Tạo đơn hàng', img: '/img/checklist.png' },
        {
          key: 'ticket', text: 'Tạo ticket', img: '/img/pass.png',
        },
      ],
    };
  },
  async created() {
    this.getDuoTestResult();
    this.getPhoneRelated(this.studentDuoDetail.contact_id);
    // this.getDataViewTable();
    await this.getListChildCustomers();
    setPageTitle(`DUO - Chi tiết - ${this.childSelected.full_name}`);
    this.mainCustomer = this.contactData.customers.find((e) => e.isMainCustomer);
    // this.setChildCustomerFullName(this.childSelected?.full_name);
    this.contactMobile = this.mainCustomer?.mobile;
    // Bus.$on('change-data-top-content-right', () => {
    //   if (this.filter.typeViewFilter === 'chart') {
    //     this.currentTab = 0;
    //     this.tabView[1].disable = true;
    //     this.getDataChart();
    //   } else if (this.filter.typeViewFilter === 'detail') {
    //     this.tabView[1].disable = false;
    //     this.getDataViewTable();
    //   }
    // });
    Bus.$on('change-data-top-content-right-subject', () => {
      if (this.filter.typeViewFilter === 'chart') {
        this.currentTab = 0;
        this.tabView[1].disable = true;
        this.getDataChart();
      } else if (this.filter.typeViewFilter === 'detail') {
        this.tabView[1].disable = false;
        // this.getDataViewTableBySubject();
      }
    });
    Bus.$on('show-modal-interaction', (val, subjectId) => {
      this.showModalInteraction = val;
      this.subjectId = subjectId;
    });
  },
  methods: {
    ...mapActions('duo_care', ['setChildCustomerFullName']),
    async getPhoneRelated(contactId) {
      const result = await StudentCareServices.getPhoneRelated(contactId);
      if (result.message === 'Success') {
        this.phoneRelated = result.data.phoneRelated;
      }
    },
    async getDuoTestResult() {
      const loading = this.$loading.show();
      const result = await StudentCareServices.getDuoTestResult({
        subjectId: this.filterForm.subjectId,
        userId: this.studentDuoDetail.lms_core_user_id,
        startTime: moment(this.filter.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filter.dateTime[1]).format('YYYY-MM-DD'),
      });
      if (result.message === 'Success') {
        this.dataTestDuo = result.data;
      }
      loading.hide();
    },
    checkChartHasData() {
      this.isShowChart = false;
      if (this.chartData && this.chartData.length > 0) {
        this.chartData.find((e) => e.type === this.activeChartType).series.forEach((e) => {
          if (e.data.find((el) => el !== 0)) {
            this.isShowChart = true;
          }
        });
      }
    },
    async getDataChart() {
      this.loading = true;
      const response = await StudentCareServices.getChartData({
        userId: this.studentDuoDetail.lms_core_user_id,
        // userId: 3565,
        currentTime: moment(new Date(this.filter.dateTime[1])).format('yyyy-MM-DD'),
        subject_id: this.filterForm.subjectId || '',
      });
      if (response.message === 'Success') {
        this.chartData = response.data;
        this.checkChartHasData();
        // let hasDataJoinClassRate = false;
        // this.chartData.find((e) => e.type === this.activeChartType).series.forEach((e) => {
        //   if (e.data.find((e) => e !== 0)) {
        //     hasDataJoinClassRate = true;
        //   }
        // })
        // const dataJoinClassRate = this.chartData.find((e) => e.type === DUO_CHART_TYPE.JOIN_CLASS_RATE).series.find((e) => e.name === 'Tỷ lệ tham gia lớp học').data;
        // const dataAverageScore = this.chartData.find((e) => e.type === DUO_CHART_TYPE.AVERAGE_SCORE).series.find((e) => e.name === 'Điểm bài tập về nhà').data;
        // if (this.activeChartType === DUO_CHART_TYPE.JOIN_CLASS_RATE && !dataJoinClassRate.find((e) => e !== 0)) {
        //   this.isShowChart = false;
        // }
        // if (this.activeChartType === DUO_CHART_TYPE.AVERAGE_SCORE && !d)
      }
      this.loading = false;
    },
    async handleCopy(code) {
      try {
        await navigator.clipboard.writeText(code);
        this.$swal({
          type: 'success',
          icon: 'success',
          showConfirmButton: false,
          toast: true,
          timer: 1000,
          title: 'Sao chép thành công!',
          position: 'top',
        });
      } catch (e) {
        console.log(e);
      }
    },
    clickExecuteCall(dataContact, phone, value) {
      if ((value === 'ZL_BGVVH' && !this.dataZalo.ZL_BGVVH) || (value === 'ZL_CVHT' && !this.dataZalo.ZL_CVHT)) {
        this.$swal({
          text: 'Học sinh / Phụ huynh đã không tương tác qua zalo với vuihoc hơn 30 ngày.',
        }); return;
      }
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: this.studentDuoDetail.contact_id,
          mainId: dataContact.mainId,
          mainMobile: this.contactMobile,
          homeroomTeacherId: this.studentDuoDetail.homeroom_teacher_id,
          studentProductId: this.studentDuoDetail.student_product_id,
          callStatusId: this.studentDuoDetail.call_status_id,
          callId: this.studentDuoDetail.call_id,
        };
        if (value && value === 'ZL_BGVVH') {
          data.mobile = 99 + this.dataZalo.zuid_ZL_BGVVH;
        }
        if (value && value === 'ZL_CVHT') {
          data.mobile = 99 + this.dataZalo.zuid_ZL_CVHT;
        }
        Bus.$emit('voice-call-show-popup', data, value);
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    createOrder(contactId) {
      const routeData = `${process.env.VUE_APP_CRM}/contact/contact-list/${contactId}/order-create`;
      window.open(routeData, '_blank');
    },
    createTicket() {
      const routeData = this.$router.resolve({
        path: '/customer-support',
        query: {
          studentId: this.studentId ? this.studentId : '',
          studentName: this.studentDuoDetail.full_name ? this.studentDuoDetail.full_name : '',
          homeRoomTeacherName: this.studentDuoDetail.homeroom_teacher_name ? this.studentDuoDetail.homeroom_teacher_name : '',
          customerCode: this.contactData.code ? this.contactData.code : '',
          module: 'Duo',
        },
      });
      window.open(routeData.href, '_blank');
    },
    changeContactChild() {
      // this.childSelected = this.childCustomers.find((e) => e.customer_id === this.childSelectedId);
      const routeData = this.$router.resolve({
        name: 'StudentDetail',
        params: { id: this.childSelectedId },
        query: {
          typeCurriculum: TYPE_CURRICULUM_OBJ.DUO,
        },
      });
      window.open(routeData.href, '_blank');
      this.childSelectedId = null;
      this.$refs['child-select'].blur();
    },
    async getDataViewTable() {
      const loading = this.$loading.show();
      this.loading = true;
      const params = {
        subjectId: this.filterForm.subjectId,
        userId: this.filterForm.lmsCoreUserID,
        startTime: moment(this.filter.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filter.dateTime[1]).format('YYYY-MM-DD'),
      };
      // const res = await StudentCareServices.homeWorkReport(params);
      const res = await ContactRepository.getListStudyDuo(params);
      if (res?.success) {
        this.dataTableBySubject = res?.data.bySubjectGrade;
      }
      this.loading = false;
      loading.hide();
      this.getDataViewTableBySubject();
    },
    changeTabView(indexTab) {
      this.currentTab = indexTab;
      this.getDataViewTable();
    },
    getDataViewTableBySubject() {
      this.dataTableBySubjectClone = _.cloneDeep(this.dataTableBySubject);
      this.dataTableBySubjectClone = this.filterForm.subjectId ? this.dataTableBySubjectClone.filter((e) => e.subjectId === +this.filterForm.subjectId) : this.dataTableBySubjectClone;
      if (this.currentTab === 1 && this.filterForm.subjectId) { // Tự học
        this.dataTableBySkill = (this.dataTableBySubjectClone && this.dataTableBySubjectClone[0]?.components.length ? this.dataTableBySubjectClone[0].components : this.dataTableBySubjectClone[0]?.skills) || [];
      }
    },
    async getListChildCustomers() {
      if (!this.studentDuoDetail?.contact_id) return;
      const res = await StudentCareServices.fgGetListCare({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum',
        ],
        'filters[$eq__contact_id]': this.studentDuoDetail.contact_id,
        'filters[$eq__type_customer_care]': this.studentDuoDetail.type_customer_care,
      });
      this.childCustomers = res?.data.filter((e) => e.customer_id !== this.studentDuoDetail.customer_id);
      this.childSelected = res?.data.find((e) => e.customer_id === this.studentDuoDetail.customer_id) || {};
      this.childSelected.birthday = this.contactData.customers.find((e) => e.id === this.childSelected.customer_id)?.birthday || '';
      this.setChildCustomerFullName(this.childSelected?.full_name);
    },
    actionUser(key) {
      if (key === 'call') {
        this.clickExecuteCall(this.contactData, this.contactMobile);
        return;
      }
      if (key === 'order') {
        this.createOrder(this.contactData.id);
      }
      if (key === 'ticket') {
        this.createTicket();
      }
    },
    formatNormalStylePhone(phone) {
      if (phone) {
        return phone.replace(/(\d{7})(\d{3})$/, 'xxxxxxx$2');
      }
      return '';
    },
    formatDate(date) {
      if (date) {
        return moment(date)
          .format('DD/MM/YYYY');
      }
      return '';
    },
  },
  computed: {
    ...mapState('duo_care', ['activeClass', 'selfStudyResult', 'studyResult']),
    isViewAll() {
      return !this.filterForm.subjectId;
    },
    checkWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    'filterForm.subjectId': function () {
      this.getDuoTestResult();
    },
    activeChartType() {
      this.checkChartHasData();
    },
    filter: {
      handler(val) {
        if (val.typeViewFilter === 'chart') {
          this.currentTab = 0;
          this.tabView[1].disable = true;
          this.getDataChart();
        } else if (val.typeViewFilter === 'detail') {
          this.tabView[1].disable = false;
          const diffDays = val.dateTime && val.dateTime.length ? parseInt((new Date(val.dateTime[1]) - new Date(val.dateTime[0])) / (1000 * 60 * 60 * 24), 10) : null;
          if (diffDays && Math.abs(diffDays) > 150) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: 'Chỉ lựa chọn khoảng thời gian tối đa 5 tháng !!',
            });
          } else {
            this.getDuoTestResult();
          }
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    Bus.$off('change-data-top-content-right-subject');
    Bus.$off('change-data-top-content-right');
    Bus.$off('show-modal-interaction');
  },
};
</script>

<style lang="scss">
.custom-duo-tab {
  .v-tab {
    background: #F8F7F7;
    border-radius: 8px;
    margin-bottom: 12px;
    color: #BBBBBB;
    text-transform: none !important;
    font-weight: normal;
  }
  .v-tab--active {
    background: #E3F0FF !important;
    color: black !important;
  }
}
</style>
<style scoped>
.col.col-4, .col.col-8 {
  background: white;
}
.col.col-3, .col.col-9 {
  background: white;
  border-radius: 8px;
}
.top-content {
  flex-wrap: nowrap;
  width: 100%;
}
.col.col-8 {
  max-width: 65% !important;
}
/deep/ .select-child > .v-input__control > .v-input__slot {
  width: 120px;
}
/deep/ .select-child .v-select__slot .theme--light.v-label {
  color: #3c88ef !important;
}
.active-tab {
  background: #e8e8ef;
}
.custom-tab .v-tabs-slider-wrapper{
  display: none !important;
}
.custom-tab .v-tab {
  border-radius: 8px;
  background-color: #F5F5F5;
  margin-bottom: 14px;
  filter: grayscale(1)
}
.custom-tab .active-tab {
  background-color: #DBECFC;
  color: #2F80ED;
  filter: none;
}
.chart-type-btn{
  padding: 8px 32px;
  background: #E0E0E0;
  border-radius: 16px;
  color: #828282;
  cursor: pointer;
}
.chart-type-btn.active {
  color: #000000;
  background: #F2994A;

}
.student-name {
  font-size: 18px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
}
</style>
<style lang="scss" scoped>
.customs-v-card {
  .v-card {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    .v-card__text {
      padding: 0px !important;
    }
  }
}
.mobile-box {
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #D3D3D3;
  color: #676767;
  padding: 5px 8px;
  transition: all .3s ease-in-out;
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &.main {
    border: 1.5px solid #6CAF60;
    color: #6CAF60;
  }
  &:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }
}
</style>
